import { useFormikContext } from 'formik'

import { ClassTypeIds, IchraClassType, canClassTypeBePairedWith, getIchraClassTypes, statesApi } from 'core'
import { StateValues } from 'core/application/commons/states'

import { PkCheckBox } from 'common/components/dataEntry/components/Checkbox'

import { CheckboxButton, CheckboxGroup, Col, DefaultSelect, Divider, Row } from 'common/components'
import { useQueryRequestV2 } from 'common/hooks'

import './styles.less'

type FormProps = {
  classTypeIds: number[]
  classTypeId: number
}

const StateCheckBoxValue = -1
const canBePaired = (classTypeId: number, selectedClassTypeIds: number[]) => {
  return selectedClassTypeIds.some((x) => !canClassTypeBePairedWith(classTypeId, x))
}

type ProductClassSelectProps = {
  isBorderedButton?: boolean
  isDisabled?: boolean
}

export const ProductClassSelect = ({ isBorderedButton = false, isDisabled = false }: ProductClassSelectProps) => {
  const CheckboxComponent = isBorderedButton ? PkCheckBox : CheckboxButton

  const { values, setFieldValue } = useFormikContext<FormProps>()

  const { data: classTypes } = useQueryRequestV2<IchraClassType[]>({
    queryFn: () => getIchraClassTypes(),
  })
  const { data: states } = useQueryRequestV2<StateValues[]>({
    queryFn: () => statesApi(),
    initialState: [],
  })

  return (
    <div className="ichra-save-product-class-form">
      <div className={'mb-32 mt-16'}>
        <h5 className={'inline mr-8 mb-32'}>Check all criteria that apply for this class:</h5>
      </div>

      <CheckboxGroup name="classTypeIds">
        {classTypes && classTypes.length > 0 && (
          <>
            <>
              <Row>
                <Col span={12}>
                  <CheckboxComponent
                    defaultChecked={values.classTypeId === ClassTypeIds.AllEligibleEmployeesId}
                    name={classTypes[0].name}
                    value={classTypes[0].id}
                    className={'w-100'}
                    disabled={canBePaired(classTypes[0].id, values.classTypeIds) || isDisabled}
                    onClick={() => {
                      setFieldValue('classTypeIds', [ClassTypeIds.AllEligibleEmployeesId])
                    }}
                  >
                    {classTypes[0].name}
                  </CheckboxComponent>
                </Col>
              </Row>
              <Divider />
            </>

            <Row gutter={8}>
              <>
                {classTypes
                  .filter((x) => x.id !== ClassTypeIds.AllEligibleEmployeesId)
                  .map((item) => (
                    <Col span={12} className={'mb-16'} key={item.id}>
                      <CheckboxComponent
                        checked={values.classTypeIds.includes(item.id)}
                        name={item.name}
                        value={item.id}
                        className={'w-100'}
                        disabled={canBePaired(item.id, values.classTypeIds) || isDisabled}
                      >
                        {item.name}
                      </CheckboxComponent>
                    </Col>
                  ))}
                <Col span={12} className={'mb-16'} key={StateCheckBoxValue}>
                  <Row gutter={16}>
                    <Col sm={24} lg={12}>
                      <CheckboxComponent
                        checked={values.classTypeIds.includes(StateCheckBoxValue)}
                        name={'State'}
                        disabled={isDisabled}
                        value={-1}
                        onChange={(e: any) => {
                          if (e.target.checked) {
                            setFieldValue('stateId', 'AL')
                          } else {
                            setFieldValue('stateId', null)
                          }
                        }}
                      >
                        State
                      </CheckboxComponent>
                    </Col>

                    <Col sm={24} lg={12}>
                      <DefaultSelect
                        disabled={!values.classTypeIds.includes(StateCheckBoxValue) || isDisabled}
                        name={'stateId'}
                        className={'w-100'}
                        wrapperClassName={'w-100'}
                        items={states.map((x) => ({ id: x.id, name: x.id }))}
                      />
                    </Col>
                  </Row>
                </Col>
              </>
            </Row>
          </>
        )}
      </CheckboxGroup>
    </div>
  )
}
